import { render, staticRenderFns } from "./AppTaskSelfie.vue?vue&type=template&id=7a439cd5"
import script from "./AppTaskSelfie.vue?vue&type=script&lang=js"
export * from "./AppTaskSelfie.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports